import { render, staticRenderFns } from "./AlternativeDashboardPage.vue?vue&type=template&id=28f745d1&scoped=true"
import script from "./AlternativeDashboardPage.vue?vue&type=script&lang=ts"
export * from "./AlternativeDashboardPage.vue?vue&type=script&lang=ts"
import style0 from "./AlternativeDashboardPage.vue?vue&type=style&index=0&id=28f745d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f745d1",
  null
  
)

export default component.exports